// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TabsHeader-module--wrapper--KRqs0";
export var item = "TabsHeader-module--item--RBwhz";
export var active = "TabsHeader-module--active--BXrd3";
export var verticalWrapper = "TabsHeader-module--verticalWrapper--q-IMK";
export var icon = "TabsHeader-module--icon--zwwMd";